const ar = {
  appName: "هانا",
  tagline: "متابعة طبية آمنة",
  loading: "جارٍ التحميل...",
  error: "حدث خطأ",
  save: "حفظ",
  cancel: "إلغاء",
  confirm: "تأكيد",
  delete: "حذف",
  edit: "تعديل",
  back: "رجوع",
  next: "التالي",
  previous: "السابق",
  submit: "إرسال",
  close: "إغلاق",
  search: "بحث",
  noData: "لا توجد بيانات",
  yes: "نعم",
  no: "لا",
  refresh: "تحديث",
  all: "الكل",
  actions: "إجراءات",
  details: "تفاصيل",
  view: "عرض",
  add: "إضافة",
  create: "إنشاء",
  update: "تحديث",
  filter: "تصفية",
  export: "تصدير",
  print: "طباعة",
  download: "تحميل",
  upload: "رفع",
  required: "مطلوب",
  optional: "اختياري",
  active: "نشط",
  inactive: "غير نشط",
  enabled: "مفعّل",
  disabled: "معطّل",
  success: "نجاح",
  warning: "تحذير",
  info: "معلومة",
  
  // Login page
  login: {
    welcome: "تسجيل الدخول",
    connectToSpace: "",
    professional: "مهني",
    patient: "مريض",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    phone: "رقم الهاتف",
    connect: "تسجيل الدخول",
    forgotPassword: "نسيت كلمة المرور؟",
    forgotPasswordTitle: "نسيت كلمة المرور",
    forgotPasswordDesc: "أدخل بريدك الإلكتروني لاستلام رابط",
    forgotPasswordPatientDesc: "تواصل مع عيادتك لإعادة التعيين",
    sendLink: "إرسال الرابط",
    requestReset: "طلب إعادة التعيين",
    backToLogin: "العودة لتسجيل الدخول",
    enterPhoneAndPassword: "الرجاء إدخال رقمك وكلمة المرور",
    enterEmail: "الرجاء إدخال بريدك الإلكتروني",
    enterPhone: "الرجاء إدخال رقم هاتفك",
    recoveryEmailSent: "تم إرسال بريد الاسترداد",
    recoveryLinkSent: "تم إرسال رابط الاسترداد",
    heroTitle: "متابعة علاج السرطان،",
    heroSubtitle: "بتنسيق أوضح بين زيارتين للمستشفى",
    heroDescription: "تساعد هناء المرضى والأقارب والفريق الطبي على الحفاظ على معلومات واضحة حول الأعراض، الرسائل، الوثائق، العلاجات الفموية والمواعيد.",
    featureSecure: "ولوج آمن حسب دور كل مستخدم",
    featurePersonalized: "متابعة بسيطة ومطمئنة للمريض",
    featureRealtime: "تنسيق علاجي أوضح للفريق الطبي",
    copyright: "© 2026 هانا الطبية. جميع الحقوق محفوظة.",
    emergencyTitle: "حالة طارئة:",
    emergencyText: "إذا كانت الحالة خطيرة أو تتدهور بسرعة، توجّه إلى أقرب مستشفى أو اتصل بـ",
    emergencyPhone: "141",
    // New auth flow translations
    loginButton: "تسجيل الدخول",
    success: "تم تسجيل الدخول بنجاح",
    trustedDeviceLogin: "تسجيل الدخول عبر جهاز موثوق",
    verify2FA: "التحقق بخطوتين",
    enter2FACode: "أدخل الرمز المرسل إلى بريدك الإلكتروني",
    enter6DigitCode: "الرجاء إدخال الرمز المكون من 6 أرقام",
    trustThisDevice: "الوثوق بهذا الجهاز (30 يوماً)",
    verifyCode: "التحقق من الرمز",
    deviceTrusted: "تم تسجيل الجهاز كجهاز موثوق",
    changePasswordTitle: "تغيير كلمة المرور",
    firstLoginChangePassword: "لأسباب أمنية، يجب عليك تغيير كلمة المرور عند أول تسجيل دخول.",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور",
    passwordsDoNotMatch: "كلمتا المرور غير متطابقتين",
    passwordMinLength: "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل",
    passwordRequirements: "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل",
    changePasswordButton: "تغيير كلمة المرور",
    patientLogin: "دخول المريض",
    hanaAccess: "ولوج هناء",
    rememberEmail: "تذكر بريدي الإلكتروني",
    rememberMe: "تذكرني",
    continue: "متابعة",
    useHanaCode: "استعمال كود هناء",
    touchIdFaceId: "Touch ID / Face ID",
    enterPhoneForOTP: "أدخل رقم هاتفك لتلقي رمز عبر الرسائل القصيرة",
    phoneNumber: "رقم الهاتف",
    sendOTP: "إرسال الرمز",
    verifyOTP: "التحقق من الرمز",
    otpSentToWhatsApp: "تم إرسال رمز عبر الرسائل القصيرة إلى الرقم",
    verifyOTPButton: "تحقق",
    changeNumber: "تغيير الرقم",
    resendOTP: "إعادة إرسال الرمز",
    resetPassword: "إعادة تعيين كلمة المرور",
    resetPasswordInstructions: "أدخل بريدك الإلكتروني لتلقي رابط إعادة التعيين",
    sendResetLink: "إرسال الرابط",
    resetEmailSent: "إذا كان هذا البريد موجوداً، فقد تم إرسال رابط إعادة التعيين",
    platformDescription: "منصة متابعة طبية آمنة للأورام",
    secure: "آمن",
    monitoring: "متابعة",
    care: "رعاية",
    allRightsReserved: "جميع الحقوق محفوظة",
  },

  resetPassword: {
    title: "كلمة مرور جديدة",
    instructions: "أنشئ كلمة مرور جديدة وآمنة لحسابك.",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور",
    requirements: "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل",
    resetButton: "إعادة تعيين كلمة المرور",
    passwordsDoNotMatch: "كلمتا المرور غير متطابقتين",
    passwordMinLength: "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل",
    success: "تم إعادة تعيين كلمة المرور",
    successDesc: "تم تغيير كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول.",
    goToLogin: "تسجيل الدخول",
    invalidLink: "رابط غير صالح",
    invalidLinkDesc: "رابط إعادة التعيين هذا غير صالح. يرجى تقديم طلب جديد.",
    linkExpired: "انتهت صلاحية الرابط",
    linkExpiredDesc: "انتهت صلاحية رابط إعادة التعيين. يرجى تقديم طلب جديد.",
    requestNewLink: "طلب رابط جديد",
    backToLogin: "العودة لتسجيل الدخول",
  },

  auth: {
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    phone: "رقم الهاتف",
    forgotPassword: "هل نسيت كلمة المرور؟",
    resetPassword: "إعادة التعيين",
    otpCode: "رمز التحقق",
    twoFACode: "رمز المصادقة",
    loginStaff: "دخول المهنيين",
    loginPatient: "دخول المريض",
    welcomeBack: "مرحباً بعودتك",
    enterCredentials: "أدخل بياناتك",
    staffPortal: "بوابة المهنيين",
    patientPortal: "فضاء المريض",
    twoFARequired: "التحقق الثنائي",
    twoFADesc: "أدخل رمز تطبيق المصادقة",
    otpDesc: "تم إرسال رمز إلى هاتفك",
    verify: "تحقق",
    firstLogin: "أول دخول",
  },

  roles: {
    SUPER_ADMIN_SAAS: "المدير العام",
    ADMIN_GROUPE: "مدير المجموعة",
    ADMIN_CLINIQUE: "مدير العيادة",
    MEDECIN: "طبيب",
    IDE: "ممرض/ة",
    SECRETAIRE_MEDICAL: "السكرتارية الطبية",
    PATIENT: "مريض",
  },

  status: {
    STABLE: "مستقر",
    OPEN_ALERT: "تنبيه مفتوح",
    TO_MONITOR: "تحت المراقبة",
    CRITICAL: "حرج",
    HOSPITALIZED: "في المستشفى",
  },

  alertLevel: {
    VERT: "عادي",
    JAUNE: "تنبيه",
    ORANGE: "تحذير",
    CRITICAL: "حرج",
  },

  checkin: {
    title: "أقول الأعراض",
    subtitle: "",
    pageUrgent: "علامات يجب إبلاغها",
    pageUrgentDesc: "اذكر أي علامة غير عادية موجودة الآن.",
    pageMain: "الأعراض",
    pageMainDesc: "اختر المستوى الأقرب.",
    pageVitalsDesc: "أدخل فقط القياسات المتوفرة.",
    urgentWarning: "اخترها إذا كانت موجودة الآن",
    alreadyDone: "تم الإرسال اليوم",
    alreadyDoneDesc: "",
    reportProblem: "الإبلاغ عن مشكلة",
    submitSuccess: "تم الإرسال",
    submitting: "جارٍ الإرسال…",
    noUrgent: "لا علامات عاجلة",
    step: "الخطوة",
    of: "من",
    urgentQuestions: "علامات سريرية",
    urgentQuestionsDesc: "أجب بنعم أو لا. عند الشك، اختر نعم.",
    urgentDetected: "سيتم إبلاغ الفريق.",
    howDoYouFeel: "الأعراض",
    chooseFace: "اختر ما تشعر به",
    lastStep: "أرقامي",
    lastStepDesc: "",
    finish: "إرسال المتابعة",
    sending: "جارٍ الإرسال…",
    backHome: "الرئيسية",
    pageSymptoms: "الأعراض",
    pageVitals: "أرقامي",
    symptomsIntro: "الأعراض",
    symptomsIntroDesc: "اختر ما تشعر به",
    nothingToReport: "أنا بخير، لا شيء أبلغ عنه",
    nothingToReportHint: "الانتقال مباشرة إلى أرقامي (اختياري)",
    vitalsOptional: "أرقامي (اختياري)",
    skipVitalsSend: "ليس لدي أرقام لإدخالها — إرسال المتابعة",
    backToSymptoms: "تعديل أعراضي",
    backHomeTop: "العودة للرئيسية",
    symptoms: {
      fatigue: "إرهاق",
      pain: "ألم",
      nausea: "غثيان / قيء",
      diarrhea: "إسهال",
      constipation: "إمساك",
      dyspnea: "صعوبة في التنفس",
      appetite: "فقدان الشهية",
      neuropathy: "تنميل / خدر",
      mucositis: "ألم الفم / تقرحات",
      rash: "طفح جلدي / مشاكل جلدية",
      bleeding: "نزيف غير عادي",
      edema: "تورم / وذمة",
      perceivedFever: "حمى محسوسة / قشعريرة",
      cough: "سعال",
      joint_pain: "آلام المفاصل",
      hot_flashes: "هبات ساخنة",
      sleep_issues: "اضطرابات النوم",
      pruritus: "حكة / جفاف الجلد",
      infection_signs: "علامات التهاب",
    },
    grades: {
      fatigue: ["لا شيء", "خفيف", "متوسط", "مهم"],
      pain: ["لا شيء", "خفيف", "متوسط", "شديد"],
      nausea: ["لا شيء", "خفيف", "قيء", "متكرر"],
      diarrhea: ["عادي", "لين", "سائل", "شديد"],
      constipation: ["عادي", "خفيف", "مزعج", "شديد"],
      dyspnea: ["لا شيء", "عند المجهود", "أدنى مجهود", "أثناء الراحة"],
      appetite: ["عادي", "ناقص", "قليل جداً", "لا شيء"],
      neuropathy: ["لا شيء", "خفيف", "متوسط", "مهم"],
      mucositis: ["لا شيء", "انزعاج", "صعوبة الأكل", "استحالة الأكل"],
      rash: ["لا شيء", "احمرار", "منتشر", "شديد"],
      bleeding: ["لا شيء", "آثار", "متوسط", "غزير"],
      edema: ["لا شيء", "خفيف", "ظاهر", "مهم"],
      perceivedFever: ["لا شيء", "حرارة", "حمى", "قشعريرة"],
      cough: ["لا شيء", "خفيف", "مزعج", "مهم"],
      joint_pain: ["لا شيء", "خفيف", "مزعج", "شديد"],
      hot_flashes: ["لا شيء", "خفيف", "مزعج", "شديد"],
      sleep_issues: ["لا شيء", "خفيف", "مزعج", "مهم"],
      pruritus: ["لا شيء", "خفيف", "مزعج", "شديد"],
      infection_signs: ["لا شيء", "خفيف", "موجود", "مهم"],
    },
    audioMessages: {
      step1_intro: "حدد حالتك الحالية. اختر المستوى الأقرب.",
      fatigue: "هل تشعر بالتعب؟",
      pain: "هل تشعر بألم؟",
      nausea: "هل تشعر بالغثيان أو القيء؟",
      diarrhea: "هل تعاني من الإسهال؟",
      constipation: "هل تعاني من الإمساك؟",
      dyspnea: "هل تجد صعوبة في التنفس؟",
      appetite: "هل شهيتك أقل من المعتاد؟",
      neuropathy: "هل تشعر بتنميل أو خدر؟",
      mucositis: "هل تعاني من ألم في الفم أو تقرحات؟",
      rash: "هل تعاني من مشاكل جلدية؟",
      bleeding: "هل لاحظت أي نزيف غير عادي؟",
      edema: "هل تعاني من تورم؟",
      perceivedFever: "هل تشعر بالحمى أو القشعريرة؟",
      cough: "هل لديك سعال؟",
      joint_pain: "هل لديك آلام في المفاصل؟",
      hot_flashes: "هل لديك هبات ساخنة؟",
      sleep_issues: "هل لديك اضطرابات في النوم؟",
      pruritus: "هل لديك حكة أو جفاف في الجلد؟",
      infection_signs: "هل لديك علامات التهاب؟",
      step2_intro: "أضف القياسات المتوفرة، ثم أكد.",
      temperature: "كم درجة حرارتك؟",
      heartRate: "كم نبضك؟",
      bloodPressure: "كم ضغط دمك؟",
      spo2: "كم نسبة الأكسجين؟",
      weight: "كم وزنك؟",
    },
    severity: {
      0: "لا شيء",
      1: "خفيف",
      2: "متوسط",
      3: "شديد",
    },
    vitals: {
      temperature: "درجة الحرارة",
      heartRate: "النبض",
      spo2: "الأكسجين (SpO2)",
      weight: "الوزن",
      bloodPressure: "ضغط الدم",
      systole: "العلوي",
      diastole: "السفلي",
    },
    pageObservance: "الالتزام",
    observanceIntro: "العلاج",
    observanceIntroDesc: "إجابة سريعة حول الجرعة.",
    observance: {
      treatmentTaken: "هل أخذت علاجك؟",
      yes: "نعم",
      partial: "جزئياً",
      no: "لا",
      missedDoses: "هل نسيت جرعات؟",
      noMissed: "لا",
      occasional: "أحياناً",
      frequent: "كثيراً",
    },
    qol: {
      title: "جودة الحياة اليوم",
      good: "جيدة",
      average: "متوسطة",
      poor: "متدهورة",
      veryPoor: "متدهورة جداً",
    },
    result: {
      titleVert: "تم إرسال المتابعة",
      descVert: "شكراً. يمكن لفريقك الاطلاع على إجاباتك.",
      titleOrange: "سيتم مراجعتها من الفريق",
      descOrange: "سيقوم فريقك بمراجعة إجاباتك.",
      titleRouge: "تم إرسال تنبيه",
      descRouge: "تم تنبيه فريقك. عند خطر فوري: 141.",
      detailsLabel: "العناصر المرسلة:",
      treatmentDay: "يوم العلاج",
      cycle: "الدورة",
      backHome: "العودة للرئيسية",
    },
    errors: {
      networkLost: "انقطع الاتصال",
      networkLostFull: "انقطع الاتصال. تم حفظ إجاباتك، يمكنك المحاولة مرة أخرى.",
      unavailable: "الخدمة غير متاحة",
      unavailableFull: "الخدمة غير متاحة مؤقتاً. أعد المحاولة بعد قليل.",
      retryHint: "تم حفظ إجاباتك. اضغط إعادة المحاولة.",
      retry: "إعادة المحاولة",
    },
    questionnaire: {
      intro: "استبيان إضافي. الوقت المتوقع: {n} دقائق.",
      introPrefix: "استبيان إضافي. الوقت المتوقع:",
      introSuffix: "دقائق.",
      skip: "تخطّي",
      send: "إرسال",
      thanks: "تم إرسال الإجابات",
      loadError: "الاستبيان غير متاح",
      vasMin: "0 - متدهور جداً",
      vasMax: "100 - ممتاز",
      label: "استبيان",
    },
  },

  patient: {
    greeting: "مرحباً",
    todayTitle: "اليوم",
    checkIn: "كيف أشعر اليوم",
    checkInDone: "تم إرسال متابعة اليوم",
    nextAppointment: "الموعد القادم",
    contactNurse: "رسالة إلى الفريق",
    medicalRecord: "الوثائق الطبية",
    noAppointment: "لا مواعيد مقررة",
    myStatus: "اليوم",
    myTreatment: "علاجي",
    myPathology: "مساري",
    pushNotifications: "التذكيرات",
    pushEnabled: "التذكير اليومي مفعل",
    pushDisabled: "التذكيرات غير مفعلة",
    pushTest: "تجربة",
    pushTesting: "جارٍ الإرسال...",
    pushDisable: "إلغاء التفعيل",
    pushDeactivated: "تم إلغاء تفعيل الإشعارات",
    pushEnable: "تفعيل",
    pushSent: "تم إرسال الإشعار.",
    pushNoSend: "لم يتم إرسال أي إشعار.",
    pushError: "خطأ أثناء الاختبار.",
    pushActivated: "تم تفعيل التذكيرات",
    pushActivateError: "تعذر التفعيل. تحقق من أذونات المتصفح.",
    loadError: "الملف غير متاح. يرجى المحاولة مرة أخرى.",
    notSpecified: "غير محدد",
    uploadResults: "إرسال التحاليل",
    homeReassurance: "هذه أهم الخطوات لمتابعتك اليوم.",
    dailyRitualLabel: "للتذكير",
    dailyRitualTitle: "في حالة طارئة أتصل. وللمتابعة أستعمل Hana.",
    dailyRitualDesc: "رسالة أو وثيقة غير مستعجلة: استعمل Hana.",
    todayActions: "ما يجب فعله اليوم",
    showMore: "عرض المزيد",
    showLess: "عرض أقل",
    careContextLabel: "المتابعة",
    careContextText: "متابعة مشتركة مع فريقك الطبي.",
    pendingQuestionsLabel: "استبيان مطلوب",
    pendingQuestionsCount: "{n} استبيان{s}",
    touchToStart: "ابدأ",
    nav: {
      home: "الرئيسية",
      followup: "المتابعة",
      team: "الفريق",
      folder: "الملف",
      messages: "مراسلاتي",
      questionnaires: "استبياناتي",
      documents: "وثائقي",
    },
    journey: {
      title: "اليوم",
      heroKicker: "مطلوب الآن",
      firstThing: "مطلوب الآن",
      sayHowIFeel: "أقول الأعراض",
      reportProblem: "الإبلاغ عن مشكلة",
      actionToday: "إجابة قصيرة للفريق",
      answerQuestions: "الإجابة على الأسئلة",
      confirmTreatment: "تأكيد الدواء",
      nothingUrgent: "لا شيء الآن",
      teamKeepsTrack: "",
      yourPath: "خطوات متابعتي",
      healthNews: "أقول الأعراض",
      done: "تم",
      toDo: "مطلوب",
      questions: "الإجابة على الأسئلة",
      noneForNow: "لا شيء مطلوب الآن",
      ok: "حسنًا",
      homeTreatment: "تأكيد الدواء",
      treatmentToComplete: "{n} جرعة",
      treatmentUpToDate: "تم التأكيد",
      noHomeTreatment: "لا شيء للتأكيد",
      planned: "مبرمج",
      none: "—",
      toConfirm: "في انتظار التأكيد",
      myTeam: "مراسلة الفريق",
      myAppointments: "رؤية المواعيد",
      unreadMessages: "{n} رسالة للقراءة",
      writeIfNeeded: "اكتب عند الحاجة خارج الطوارئ",
      available: "متاح",
      sendBilanSubtitle: "صورة أو PDF قبل العلاج",
      send: "إرسال",
      myFolder: "رؤية الوثائق",
      documentsAndResults: "الوثائق والنتائج هنا",
      open: "فتح",
      advice: "قراءة النصائح",
      shortAdvice: "اقرأها عندما يكون لديك وقت",
      read: "قراءة",
      careToday: "ما يجب فعله",
      pendingShort: "مطلوب",
      myServices: "إجراءات أخرى",
      quickAccess: "بسيط ومباشر",
    },
    audio: {
      listen: "استمع",
    },
    audioMessages: {
      home_symptoms: "الشيك إن. قولي لينا كيفاش حاسة اليوم. هاد الشي كيساعد فريق هناء يتابع حالتك.",
      home_report_problem: "بلغي على مشكل. استعملي هاد الزر إلا تبدل شي حاجة خارج الشيك إن ديال اليوم.",
      home_questions: "استبياناتي. جاوبي على الأسئلة الطبية بشوية بشوية، سؤال بسؤال.",
      home_medicine: "علاجي. أكدي واش خديتي الدوا ديالك فالدار ولا لا.",
      home_bilan: "إرسال نتائجي. صيفطي هنا تحاليل ما قبل الكيميو للفريق التمريضي.",
      home_team: "الفريق. كتبي لفريق هناء إلا كان عندك سؤال ماشي مستعجل.",
      home_documents: "ملفي. شوفي الوثائق الطبية ديالك، أو زيدي وثيقة أخرى ماشي تحليل ما قبل الكيميو.",
      home_appointments: "مواعيدي. شوفي المواعيد المبرمجة مع الفريق الطبي.",
      home_advice: "التثقيف. هنا تلقاي نصائح باش تفهمي المتابعة ديالك مزيان.",
      home_emergency: "إلا كانت حالة مستعجلة، ما تسنايش فالابليكاسيون. عيطي لمية واحد وأربعين ولا سيري للسبيطار.",
    },
    statusNotes: {
      STABLE: "لا توجد إشارة خاصة في متابعتك حالياً.",
      OPEN_ALERT: "لدى فريقك تنبيه مفتوح للمراجعة.",
      TO_MONITOR: "فريقك يتابع حالتك باهتمام.",
      CRITICAL: "تم إبلاغ فريقك وهو يتابع حالتك عن قرب.",
      HOSPITALIZED: "تتم متابعتك مع الفريق الموجود في المركز.",
    },
    statusLabels: {
      CRITICAL: "متابعة قريبة",
    },
    oralAdherence: {
      title: "العلاج الفموي",
      subtitle: "أكد فقط جرعة اليوم.",
      scheduledDate: "الجرعة المقررة",
      savedTaken: "تم تأكيد الجرعة",
      savedNotTaken: "تم إرسال المعلومة",
      saveError: "هذه الجرعة لا يمكن تأكيدها الآن",
      upToDate: "تم تأكيد جرعة اليوم. التأكيد القادم عند الجرعة التالية.",
      todayChip: "اليوم",
      takenShort: "أُخذت",
      notTakenShort: "لا",
      extraCount: "جرعة أخرى للتأكيد.",
      extraCountPlural: "{n} جرعات أخرى للتأكيد.",
    },
    layout: {
      legal: "الوثائق القانونية",
      logout: "تسجيل الخروج",
      emergencyPrefix: "حالة طارئة:",
      emergencyAppNotice: "اتصل بـ 141 أو اذهب إلى المستشفى.",
      emergencyActionBeforePhone: "",
      emergencyPhoneLabel: "141",
      pushTitle: "تفعيل التذكيرات",
      pushDesc: "استلام تذكير يومي.",
      pushActivate: "تفعيل",
    },
    questionnaires: {
      title: "الأسئلة",
      subtitle: "",
      backList: "رجوع",
      backHome: "الرئيسية",
      loadError: "تعذر التحميل",
      completed: "تم الإرسال",
      emptyTitle: "لا أسئلة",
      emptyDesc: "",
      visit: "زيارة",
      due: "مقرر في",
    },
    frequency: {
      title: "المتابعة مقررة",
      DAILY: "كل يوم",
      EVERY_2_DAYS: "كل يومين",
      "3X_WEEK": "3 مرات في الأسبوع",
      "1X_WEEK": "مرة في الأسبوع",
      upToDate: "مكتمل",
      nextToday: "اليوم",
      nextTomorrow: "غداً",
      nextFewDays: "في الأيام القادمة",
      nextThisWeek: "هذا الأسبوع",
      notToday: "ليس اليوم",
      nextCheckin: "المتابعة القادمة",
    },
  },

  nurse: {
    dashboard: "لوحة التحكم",
    patientList: "مرضاي",
    todayAlerts: "تنبيهات اليوم",
    criticalPatients: "حرجون",
    monitorPatients: "تحت المراقبة",
    stablePatients: "مستقرون",
    hospitalizedPatients: "في المستشفى",
    noCheckin48h: "بدون متابعة >48س",
    unreadMessages: "رسائل غير مقروءة",
    noAlerts: "لا تنبيهات نشطة",
    lastCheckin: "آخر متابعة",
    assignAlert: "تكفل بالتنبيه",
    resolveAlert: "حل",
    escalateAlert: "تصعيد",
    writeTransmission: "كتابة تقرير",
    changeStatus: "تغيير الحالة",
    transmission: "التقرير",
    transmissionRequired: "التقرير إلزامي",
    priorityPatients: "المرضى ذوو الأولوية",
    noPriorityPatients: "لا مرضى ذوي أولوية",
    viewAll: "عرض الكل",
  },

  doctor: {
    dashboard: "لوحة التحكم",
    criticalPatients: "المرضى الحرجون",
    pendingRequests: "طلبات التمريض",
    escalatedAlerts: "التنبيهات المصعّدة",
    pendingValidations: "للتصديق",
    writePrescription: "كتابة وصفة طبية",
    writeTransmission: "كتابة تقرير",
    validateAlert: "تصديق",
    resolveAlert: "حل",
  },

  messages: {
    title: "مراسلة الفريق",
    subtitle: "خارج الطوارئ",
    newMessage: "اكتب",
    newConversation: "محادثة جديدة",
    send: "إرسال",
    placeholder: "اكتب لفريقك…",
    noMessages: "لا رسائل",
    noMessagesHint: "اكتب لسؤال غير مستعجل.",
    noConversations: "لا محادثات",
    you: "أنت",
    unread: "غير مقروءة",
    yesterday: "أمس",
    today: "اليوم",
    selectConversation: "اختر محادثة",
    typeMessage: "اكتب رسالتك...",
    startConversation: "اكتب لفريقي",
    teamAvailable: "",
    teamAvailabilityTitle: "",
    teamAvailabilityDesc: "",
    recipient: "المستلم",
    subject: "الموضوع",
    selectRecipient: "اختر مستلم",
    clinicians: "الأطباء",
    patients: "المرضى",
    conversationCreated: "الرسالة جاهزة",
    conversationRemoved: "تم إخفاء المحادثة",
    removeConversation: "إخفاء هذه المحادثة",
    removeConversationConfirm: "هل تريد إخفاء هذه المحادثة من قائمتك؟\nسيحتفظ بها الفريق في الملف.",
    loadError: "تعذر التحميل",
    olderMessages: "عرض الرسائل السابقة",
    defaultThreadName: "فريقي",
    attachFile: "إضافة مرفق",
    fileTooLarge: "الملف كبير جداً (الحد الأقصى 10 م.ب)",
    fileSent: "تم إرسال المرفق",
    sendError: "تعذر الإرسال",
    error: "خطأ",
    viewPhoto: "عرض الصورة",
    photoAlt: "صورة مرسلة",
    emergencyReminder: "Hana ليست خدمة طوارئ. عند خطر فوري: اتصل بـ 141 أو توجّه إلى أقرب مستشفى.",
    intentSymptom: "عرض",
    intentQuestion: "سؤال",
    intentTreatment: "دواء",
    intentDocument: "وثيقة",
    intentSymptomTemplate: "أريد إبلاغكم عن عرض: ",
    intentQuestionTemplate: "لدي سؤال: ",
    intentTreatmentTemplate: "لدي سؤال حول علاجي: ",
    intentDocumentTemplate: "أريد الحديث عن وثيقة طبية: ",
  },

  documents: {
    title: "الوثائق",
    patientTitle: "الوثائق",
    subtitle: "",
    prescription: "وصفة طبية",
    labResult: "نتيجة المختبر",
    report: "تقرير",
    imaging: "تصوير طبي",
    upload: "إرسال وثيقة",
    download: "تحميل",
    noDocuments: "لا وثائق متاحة",
    noDocumentsTitle: "لا وثائق",
    noDocumentsHint: "",
    type: "النوع",
    date: "التاريخ",
    description: "الوصف",
    uploadedBy: "أضافه",
    uploadDocument: "إرسال وثيقة",
    all: "الكل",
    uploadFirst: "إرسال وثيقة",
    downloadError: "تعذر التحميل",
    selectFileAndType: "اختر الملف ونوع الوثيقة.",
    uploadSuccess: "تم إرسال الوثيقة",
    uploadError: "تعذر إرسال الوثيقة",
    types: {
      prescription: "وصفة طبية",
      lab_result: "نتيجة تحليل",
      medical_report: "تقرير طبي",
      imaging: "تصوير طبي",
      consent_form: "موافقة",
      other: "آخر",
    },
    uploadModalTitle: "إرسال وثيقة",
    sourcePatient: "أضفته أنت",
    sourceLab: "أضافه المختبر",
    sourceImaging: "أضافه التصوير الطبي",
    sourceTeam: "أضافه الفريق",
    sourceAvailable: "وثيقة متاحة",
    statusReceived: "تم الاستلام",
    statusClassified: "مصنّف",
    statusAvailable: "متاح",
    unsureType: "لا أعرف",
    unsureTypeHint: "",
    file: "الملف",
    chooseFile: "اختر ملفاً",
    fileFormats: "PDF, JPG, PNG, DOC (الحد الأقصى 10 م.ب)",
    sending: "جارٍ الإرسال...",
    send: "إرسال",
  },

  appointments: {
    title: "المواعيد",
    subtitle: "",
    request: "طلب موعد",
    requestAppointment: "طلب موعد",
    newAppointment: "موعد جديد",
    pendingRequests: "الطلبات المعلقة",
    status: {
      PROPOSED: "قيد الانتظار",
      CONFIRMED: "مؤكد",
      DECLINED: "مرفوض",
      CANCELLED: "ملغى",
      COMPLETED: "مكتمل",
    },
    noAppointments: "لا مواعيد",
    date: "التاريخ",
    time: "الوقت",
    location: "المكان",
    notes: "ملاحظات",
    type: "نوع الموعد",
    selectType: "اختر...",
    types: {
      consultation: "استشارة",
      followup: "متابعة",
      chemotherapy: "علاج كيميائي",
      radiotherapy: "علاج إشعاعي",
      checkup: "فحص",
      emergency: "طوارئ",
    },
    confirm: "تأكيد",
    cancel: "إلغاء",
    complete: "إنهاء",
    confirmAppointment: "تأكيد الموعد",
    cancelAppointment: "هل تريد إلغاء هذا الموعد؟",
    selectDateTime: "التاريخ والوقت",
    referringDoctor: "الطبيب المعالج للمريض",
    selectDoctor: "اختر طبيب",
    selectPatient: "اختر مريض",
    searchPatient: "البحث عن مريض...",
    create: "طلب",
    appointmentCreated: "تم إنشاء الطلب",
    appointmentConfirmed: "تم تأكيد الموعد",
    appointmentCancelled: "تم إلغاء الموعد",
    appointmentCompleted: "تم إنهاء الموعد",
    // Patient actions for doctor-proposed appointments
    proposedByDoctor: "اقتراح موعد",
    accept: "قبول",
    decline: "رفض",
    accepted: "تم قبول الموعد",
    declined: "تم رفض الموعد",
    dateToConfirm: "التاريخ للتأكيد",
    loadError: "خطأ في التحميل",
    requestSuccess: "تم إرسال الطلب",
    notesPlaceholder: "سبب الموعد…",
    declarativeBadge: "العيادة",
    declarativeTooltip: "موعد مسجل من طرف العيادة.",
    error: "خطأ",
  },

  alerts: {
    title: "التنبيهات",
    status: {
      NEW: "جديد",
      IN_PROGRESS: "قيد المعالجة",
      RESOLVED: "محلول",
      ESCALATED: "مصعّد",
      VALIDATED: "مصدّق",
    },
    level: {
      ORANGE: "تحذير",
      CRITICAL: "حرج",
    },
    noAlerts: "لا تنبيهات",
    reasons: "الأسباب",
    since: "منذ",
    resolve: "حل",
    escalate: "تصعيد",
    validate: "تصديق",
    resolution: "الحل",
    outcome: "النتيجة",
    notes: "ملاحظات",
    escalationReason: "سبب التصعيد",
    resolveOrEscalate: "حل أو تصعيد",
    resolveAlert: "حل التنبيه",
    escalateAlert: "تصعيد التنبيه",
    markAsResolved: "تحديد كمحلول",
    escalateToDoctor: "تصعيد للطبيب",
    outcomes: {
      NO_ACTION: "لا إجراء مطلوب",
      PHONE_CALL: "مكالمة هاتفية",
      APPOINTMENT: "موعد مقرر",
      HOSPITALIZATION: "دخول المستشفى",
      MEDICATION_CHANGE: "تغيير العلاج",
      OTHER: "آخر",
    },
  },

  nav: {
    home: "الرئيسية",
    patients: "المرضى",
    alerts: "التنبيهات",
    messages: "الرسائل",
    documents: "الوثائق",
    appointments: "المواعيد",
    myRequests: "طلباتي",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    logout: "خروج",
    dashboard: "لوحة التحكم",
    workqueue: "تسليم التمريض",
    workqueueSecretary: "دفتر المهام",
    orders: "الوصفات",
    education: "التثقيف الصحي",
    medicalRecord: "الملف الطبي",
    clinicAdmin: "إدارة العيادة",
    reviews: "للتصديق",
    triage: "تحاليل للفرز",
  },

  admin: {
    dashboard: "الإدارة",
    manageUsers: "إدارة المستخدمين",
    manageClinics: "إدارة العيادات",
    managePatients: "إدارة المرضى",
    stats: "الإحصائيات",
    billing: "الفوترة",
    audios: "إدارة الأصوات",
    kpi: "المؤشرات",
    users: "المستخدمين",
    clinics: "العيادات",
    groups: "المجموعات",
    createUser: "إنشاء مستخدم",
    createClinic: "إنشاء عيادة",
    createPatient: "إنشاء مريض",
    editUser: "تعديل المستخدم",
    editClinic: "تعديل العيادة",
    editPatient: "تعديل المريض",
    deactivate: "إلغاء التفعيل",
    activate: "تفعيل",
    resetPassword: "إعادة تعيين كلمة المرور",
    newPassword: "كلمة المرور الجديدة",
    userCreated: "تم إنشاء المستخدم",
    userUpdated: "تم تحديث المستخدم",
    userDeactivated: "تم إلغاء تفعيل المستخدم",
    userActivated: "تم إعادة تفعيل المستخدم",
    passwordReset: "تم إعادة تعيين كلمة المرور",
    clinicCreated: "تم إنشاء العيادة",
    patientCreated: "تم إنشاء المريض",
    patientUpdated: "تم تحديث المريض",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    role: "الدور",
    clinic: "العيادة",
    group: "المجموعة",
    dateOfBirth: "تاريخ الميلاد",
    address: "العنوان",
    pathology: "المرض",
    treatment: "العلاج",
    height: "الطول (سم)",
    referringDoctor: "الطبيب المعالج",
    selectClinic: "اختر عيادة",
    selectRole: "اختر دور",
    selectDoctor: "اختر طبيب",
    noUsersFound: "لم يتم العثور على مستخدمين",
    noClinicsFound: "لم يتم العثور على عيادات",
    noPatientsFound: "لم يتم العثور على مرضى",
    showInactive: "إظهار غير النشطين",
    clinicName: "اسم العيادة",
    clinicAddress: "عنوان العيادة",
  },

  orders: {
    laboratoire: "مختبر",
    pharmacie: "صيدلية",
    imagerie: "تصوير",
    status: {
      RECEIVED: "مستلم",
      IN_PROGRESS: "قيد التنفيذ",
      COMPLETED: "مكتمل",
    },
    accept: "قبول",
    complete: "إنهاء",
    uploadResult: "رفع النتيجة",
    homeDelivery: "توصيل منزلي",
    newOrders: "طلبات جديدة",
    inProgress: "قيد التنفيذ",
    completed: "مكتملة",
  },

  // Patient detail pages
  patientDetail: {
    overview: "نظرة عامة",
    checkins: "المتابعات",
    alerts: "التنبيهات",
    transmissions: "التقارير",
    documents: "الوثائق",
    info: "معلومات",
    pathology: "المرض",
    treatment: "العلاج",
    referringDoctor: "الطبيب المعالج",
    phone: "الهاتف",
    dateOfBirth: "تاريخ الميلاد",
    address: "العنوان",
    height: "الطول",
    weight: "الوزن",
    lastCheckin: "آخر متابعة",
    noCheckins: "لا متابعات",
    urgentSymptoms: "أعراض طارئة",
    mainSymptoms: "الأعراض الرئيسية",
    vitals: "القياسات الحيوية",
    charts: "الرسوم البيانية",
    evolution: "التطور",
    temperatureEvolution: "تطور درجة الحرارة",
    heartRateEvolution: "تطور النبض",
    bloodPressureEvolution: "تطور ضغط الدم",
    spo2Evolution: "تطور الأكسجين (SpO2)",
    weightEvolution: "تطور الوزن",
    noChartData: "لا توجد بيانات كافية لعرض الرسوم البيانية",
    chartDataWillAppear: "ستظهر الرسوم البيانية بعد عدة متابعات",
    feverThreshold: "عتبة الحمى",
    lowThreshold: "العتبة الدنيا",
    systolic: "الانقباضي",
    diastolic: "الانبساطي",
    imc: "مؤشر كتلة الجسم",
    changeStatus: "تغيير الحالة",
    newStatus: "الحالة الجديدة",
    transmissionRequired: "التقرير إلزامي لهذا التغيير",
    writeTransmission: "اكتب تقريراً...",
    statusChanged: "تم تحديث الحالة",
    editPatient: "تعديل المريض",
    callPatient: "الاتصال بالمريض",
    requestAppointment: "طلب موعد",
    newTransmission: "تقرير جديد",
    writeTransmissionPlaceholder: "اكتب تقريراً...",
    transmissionSent: "تم إرسال التقرير",
    noTransmissions: "لا تقارير",
    noDocuments: "لا وثائق",
    noAlerts: "لا تنبيهات",
    uploadDocument: "إضافة وثيقة",
    documentUploaded: "تم رفع الوثيقة",
  },

  // Common form labels
  form: {
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    password: "كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    save: "حفظ",
    cancel: "إلغاء",
    submit: "إرسال",
    required: "هذا الحقل مطلوب",
    invalidEmail: "بريد إلكتروني غير صالح",
    invalidPhone: "رقم هاتف غير صالح",
    passwordTooShort: "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل",
  },

  // Error messages
  errors: {
    generic: "حدث خطأ",
    network: "خطأ في الاتصال",
    unauthorized: "غير مصرح",
    forbidden: "الوصول ممنوع",
    notFound: "غير موجود",
    validation: "خطأ في التحقق",
    serverError: "خطأ في الخادم",
  },

  // Time and dates
  time: {
    today: "اليوم",
    yesterday: "أمس",
    tomorrow: "غداً",
    thisWeek: "هذا الأسبوع",
    lastWeek: "الأسبوع الماضي",
    thisMonth: "هذا الشهر",
    lastMonth: "الشهر الماضي",
    ago: "منذ",
    in: "خلال",
    minutes: "دقائق",
    hours: "ساعات",
    days: "أيام",
    weeks: "أسابيع",
    months: "أشهر",
  },

  // Studies module
  studies: {
    title: "الدراسات السريرية",
    createStudy: "إنشاء دراسة",
    studyTitle: "عنوان الدراسة",
    sponsor: "الراعي",
    description: "الوصف",
    status: "الحالة",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    inclusionCriteria: "معايير الإدراج",
    questionnaires: "الاستبيانات",
    visits: "الزيارات",
    enrollments: "التسجيلات",
    enrolled: "مسجل",
    eligible: "مؤهل",
    noStudies: "لا توجد دراسات",
    enrollPatient: "تسجيل مريض",
    viewDetails: "عرض التفاصيل",
    dashboard: "لوحة المتابعة",
    adherence: "الالتزام",
    exportData: "تصدير البيانات",
    pendingQuestionnaires: "استبيانات معلقة",
    completeQuestionnaire: "أكمل الاستبيان",
    skipQuestionnaire: "تخطي",
    questionnaireCompleted: "تم إكمال الاستبيان",
    scores: "النتائج",
    visitSchedule: "جدول الزيارات",
    cancerType: "نوع السرطان",
    minAge: "الحد الأدنى للعمر",
    maxAge: "الحد الأقصى للعمر",
    treatmentType: "نوع العلاج",
    addVisit: "إضافة زيارة",
    visitName: "اسم الزيارة",
    dayOffset: "اليوم (من التسجيل)",
    selectQuestionnaires: "اختيار الاستبيانات",
    studyCreated: "تم إنشاء الدراسة",
    patientEnrolled: "تم تسجيل المريض",
    active: "نشطة",
    completed: "مكتملة",
    draft: "مسودة",
    paused: "متوقفة",
    step3Title: "استبيان الدراسة",
    step3Desc: "لديك استبيان في إطار دراسة سريرية.",
    progress: "التقدم",
    question: "سؤال",
    of: "من",
    studyBadge: "دراسة",
    noEligiblePatients: "لا مرضى مؤهلين",
    findEligible: "بحث عن المؤهلين",
    consent: "الموافقة",
    consentObtained: "تم الحصول على الموافقة",
  },

  // Education module
  education: {
    title: "نصائح العناية",
    subtitle: "نصائح قصيرة اختارها فريقك لمسارك.",
    recommended: "للقراءة",
    explore: "المواضيع",
    myProgress: "التقدم",
    myRecent: "شوهد مؤخراً",
    contents: "نصائح",
    consultedProgress: "{completed} من {total} تمت قراءتها",
    completed: "تمت القراءة",
    inProgress: "قيد التنفيذ",
    toWatch: "للمشاهدة",
    understood: "فهمت",
    askQuestion: "سؤال",
    startQuestionnaire: "استبيان",
    keyPoints: "للتذكر",
    backToEducation: "رجوع",
    questionSent: "تم إرسال السؤال إلى الفريق",
    noContent: "لا توجد نصائح متاحة",
    contentWillAppear: "ستظهر النصائح هنا.",
    categoryContentsWillAppear: "ستظهر نصائح هذا الموضوع هنا.",
    contentNotFound: "النصيحة غير موجودة",
    viewed: "تمت المشاهدة",
    understoodThanks: "تم",
    askComprehension: "هل هذه النصيحة واضحة؟",
    understandRecorded: "تم تسجيل الإجابة",
    recordError: "تعذر التسجيل",
    loadContentError: "النصيحة غير متاحة",
    loadContentsError: "النصائح غير متاحة",
    pleaseTypeQuestion: "اكتب سؤالك",
    sendQuestionError: "تعذر إرسال السؤال",
    questionModalTitle: "سؤال للفريق",
    questionModalDesc: "",
    contentLabel: "النصيحة",
    questionPlaceholder: "سؤالك…",
    sendingQuestion: "جارٍ الإرسال…",
    sendQuestion: "إرسال",
    questionnaireGood: "تم تأكيد الفهم.",
    questionnaireNeedsReview: "يمكن مراجعة بعض النقاط.",
    questionnairePoor: "يمكنك إعادة قراءة هذه النصيحة لاحقاً.",
    correctAnswers: "إجابات صحيحة",
    closeBtn: "إغلاق",
    sendingQuestionnaire: "جارٍ الإرسال...",
    submitAnswers: "تأكيد",
    questionnaireCompleted: "تم إرسال الاستبيان",
    questionnaireSubmitError: "تعذر الإرسال",
    categories: {
      BIENVENUE: "مرحباً",
      TRAITEMENT: "العلاج",
      NUTRITION: "التغذية",
      EFFETS_SECONDAIRES: "الآثار الجانبية",
      SIGNES_ALERTE: "علامات التحذير",
      BIEN_VIVRE: "جودة الحياة",
      GESTION_SYMPTOMES: "إدارة الأعراض",
    },
    categoryDescriptions: {
      BIENVENUE: "اكتشف مسار علاجك",
      TRAITEMENT: "فهم علاجك",
      NUTRITION: "نصائح غذائية",
      EFFETS_SECONDAIRES: "إدارة الآثار الجانبية",
      SIGNES_ALERTE: "متى تتصل بالفريق الطبي",
      BIEN_VIVRE: "جودة الحياة اليومية",
      GESTION_SYMPTOMES: "تخفيف أعراضك",
    },
  },

  biology: {
    title: "إرسال نتائجي",
    subtitle: "قبل العلاج — بحد أقصى {n} صفحات",
    sampleDate: "تاريخ التحليل",
    pagesAdded: "صفحة(صفحات) مضافة",
    cameraBtn: "صورة",
    galleryBtn: "المعرض",
    pdfBtn: "PDF",
    photoHint: "أضف كل صفحة من التحليل، أو ملف PDF.",
    sendBilan: "إرسال التحليل",
    sendPdf: "إرسال PDF",
    sending: "جارٍ الإرسال…",
    pdfBadge: "PDF",
    maxPagesReached: "تم بلوغ الحد الأقصى للصفحات",
    pdfTooLarge: "ملف PDF كبير جداً (الحد الأقصى 20 م.ب)",
    onlyOnePdf: "أرسل ملف PDF واحد فقط، أو صور.",
    removePhotosFirst: "أزل الصور أولاً قبل إضافة ملف PDF.",
    removePdfFirst: "أزل ملف PDF أولاً قبل إضافة صور.",
    imageError: "خطأ في معالجة الصورة",
    imageProcessing: "معالجة الصور...",
    needAtLeastOnePage: "أضف صفحة أو ملف PDF",
    uploading: "جارٍ إرسال التحليل…",
    uploadSuccess: "تم إرسال التحليل",
    uploadSuccessDesc: "",
    uploadError: "تعذر الإرسال. يرجى المحاولة مرة أخرى",
    removePdfAria: "إزالة ملف PDF",
    removePageAria: "حذف",
    closeAria: "إغلاق",
  },
};

export default ar;
